import React, { Component } from "react";
import AntdBreadcrumb, {BreadcrumbProps} from "antd/lib/breadcrumb";
import "antd/lib/breadcrumb/style";

const { Item } = AntdBreadcrumb;
export default class Breadcrumb extends Component<BreadcrumbProps> {
  static Item = Item;
  render() {
    return <AntdBreadcrumb {...this.props} />;
  }
}



// WEBPACK FOOTER //
// ./src/components/breadcrumb/index.tsx